(() => {
  if (customElements.get("p-split-cards")) return;

  class PSplitCards extends HTMLElement {
    constructor() {
      super();
      this.swiper_instance = null;
      this.resize_timer = 0;
      this.bound_resize = this.handle_resize.bind(this);
      this.bound_block_select = this.handle_block_select.bind(this);
    }

    connectedCallback() {
      this.swiper_el = this.querySelector("[data-p-split-swiper]");
      this.pagination_el = this.querySelector("[data-p-split-pagination]");
      this.enable_carousel = this.dataset.enableCarousel === "true";
      this.enable_loop = this.dataset.loop === "true";

      this.wait_for_swiper(() => {
        this.sync_swiper();
        window.addEventListener("resize", this.bound_resize, { passive: true });
      });

      document.addEventListener("shopify:block:select", this.bound_block_select);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.bound_resize);
      document.removeEventListener("shopify:block:select", this.bound_block_select);
      this.destroy_swiper();
    }

    wait_for_swiper(callback, retry) {
      retry = retry || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (retry > 20) return;
      setTimeout(() => this.wait_for_swiper(callback, retry + 1), 120);
    }

    is_mobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    }

    should_use_swiper() {
      return this.enable_carousel && this.is_mobile();
    }

    handle_resize() {
      window.clearTimeout(this.resize_timer);
      this.resize_timer = window.setTimeout(() => this.sync_swiper(), 150);
    }

    sync_swiper() {
      if (this.should_use_swiper()) {
        this.init_swiper();
        return;
      }
      this.destroy_swiper();
    }

    init_swiper() {
      if (this.swiper_instance || !this.swiper_el || typeof window.Swiper !== "function") return;

      const slide_count = this.swiper_el.querySelectorAll(".p-split__card").length;
      if (slide_count === 0) return;

      const reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      this.swiper_instance = new window.Swiper(this.swiper_el, {
        slidesPerView: "auto",
        spaceBetween: this.resolve_gap(),
        slidesOffsetAfter: 16,
        speed: reduce_motion ? 0 : 450,
        loop: this.enable_loop && slide_count > 1,
        watchOverflow: true
      });
    }

    resolve_gap() {
      const root = this.closest(".p-split");
      const gap_raw = root ? window.getComputedStyle(root).getPropertyValue("--card-gap-m") : "";
      const gap = parseFloat(gap_raw);
      return Number.isFinite(gap) ? gap : 13;
    }

    destroy_swiper() {
      if (!this.swiper_instance) return;
      this.swiper_instance.destroy(true, true);
      this.swiper_instance = null;
    }

    handle_block_select(event) {
      if (!this.swiper_instance || !event.target) return;
      const slide_el = event.target.closest(".p-split__card");
      if (!slide_el || !this.contains(slide_el)) return;

      const index = Number(slide_el.dataset.swiperSlideIndex);
      if (Number.isFinite(index)) {
        this.swiper_instance.slideToLoop(index);
        return;
      }

      const slides = slide_el.parentNode ? slide_el.parentNode.children : [];
      this.swiper_instance.slideTo(Array.prototype.indexOf.call(slides, slide_el));
    }
  }

  customElements.define("p-split-cards", PSplitCards);
})();
